import _Student from './student';
import { AttendanceStatus as _Status } from 'data/SessionsAttendance/status';

export const Student = _Student;
export const Status = _Status;
export const AttendanceStatus = _Status;

Student.Status = Status;

export default Student;



// WEBPACK FOOTER //
// ./containers/Group/Attendance/MarkAttendance/MarkAttendanceDayView/Student/index.js